import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-011f10bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-12" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header flex-column flex-nowrap justify-content-around pb-2 pt-6 px-3 mx-6\" data-v-011f10bc><div class=\"card-title m-0 py-3\" data-v-011f10bc><h3 class=\"fw-bolder m-0\" data-v-011f10bc>Account Details</h3></div><div class=\"card-subtitle row py-3\" data-v-011f10bc><label class=\"col-lg-6 text-muted\" data-v-011f10bc>ประเภทรายละเอียด / Labels</label><label class=\"col-lg-6 text-muted\" data-v-011f10bc>รายละเอียด / Details</label></div></div>", 1)
const _hoisted_3 = { class: "px-9 pb-9" }
const _hoisted_4 = { class: "col-lg-6 fw-bold" }
const _hoisted_5 = {
  key: 0,
  class: "col-lg-6 fw-bold fs-6 text-dark"
}
const _hoisted_6 = {
  key: 1,
  class: "col-lg-6 fw-bold fs-6 text-dark"
}
const _hoisted_7 = {
  class: "modal fade",
  tabindex: "-1",
  id: "modal"
}
const _hoisted_8 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_9 = { class: "modal-content bg-transparent shadow-none" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "card-header border-0 pt-6" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = { class: "card-label" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "symbol symbol-150px" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img overlay-layer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-white" }, " image_search ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PartnerDetailsCard = _resolveComponent("PartnerDetailsCard")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PartnerDetailsCard, {
      data: $setup.data,
      onChangeImage: $setup.changeImage
    }, null, 8, ["data", "onChangeImage"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.labels, (label, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "row py-6 border-bottom"
          }, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(label.name || '-'), 1),
            ($setup.timeFormat.includes(label.key))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.moment($setup.data[label.key]).format('ll') || '-'), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(label?.key2
              ? $setup.data[label.key]?.[0]?.[label.key2] || '-'
              : $setup.data[label.key] || '-'), 1))
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            class: "figure-img img-fluid rounded m-0",
            src: 
            $setup.currentImage ||
            'https://media.istockphoto.com/vectors/error-page-or-file-not-found-icon-vector-id924949200?k=20&m=924949200&s=170667a&w=0&h=-g01ME1udkojlHCZeoa1UnMkWZZppdIFHEKk6wMvxrs='
          ,
            alt: "modal image"
          }, null, 8, _hoisted_10)
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documents, (document, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "card mb-12"
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h1", _hoisted_13, _toDisplayString(`${document.name} Document`), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([document.data.length ? 'py-0' : 'pt-0', "card-body"])
        }, [
          _createVNode(_component_Datatable, {
            "table-header": $setup.documentHeader,
            "table-data": document.data,
            enableItemsPerPageDropdown: false
          }, {
            "cell-image": _withCtx(({ row }) => [
              _createElementVNode("div", {
                class: "overlay cursor-pointer",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal",
                onClick: ($event: any) => ($setup.changeImage(row.image))
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: row.image,
                    alt: "document image"
                  }, null, 8, _hoisted_16),
                  _hoisted_17
                ])
              ], 8, _hoisted_14)
            ]),
            "cell-title": _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.title), 1)
            ]),
            _: 2
          }, 1032, ["table-header", "table-data"])
        ], 2)
      ]))
    }), 128))
  ], 64))
}